import { useRef, type ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import s from './StepWindFacilityData.module.scss';

const FACILITY_TRANSITION_TIMEOUT = {
  appear: 500,
  enter: 500,
  exit: 500,
} as const;

const FACILITY_TRANSITION_CLASS_NAMES = {
  enter: s['facility-transition-enter'],
  enterActive: s['facility-transition-enter-active'],
  exit: s['facility-transition-exit'],
  exitActive: s['facility-transition-exit-active'],
};

interface FacilityFormTransitionProps {
  children: ReactNode;
  in?: boolean;
  appear?: boolean;
  enter?: boolean;
  exit?: boolean;
  /** Injected by TransitionGroup; node is supplied via nodeRef when using CSSTransition. */
  onExited?: (node: HTMLElement | null) => void;
}

/**
 * CSSTransition wrapper for facility FieldArray items.
 */
function FacilityFormTransition({
  children,
  in: inProp,
  appear,
  enter,
  exit,
  onExited,
}: FacilityFormTransitionProps) {
  const nodeRef = useRef<HTMLDivElement>(null);

  const handleExited = () => {
    onExited?.(nodeRef.current);
  };

  return (
    <CSSTransition
      nodeRef={nodeRef}
      in={inProp}
      appear={appear}
      enter={enter}
      exit={exit}
      onExited={handleExited}
      timeout={FACILITY_TRANSITION_TIMEOUT}
      classNames={FACILITY_TRANSITION_CLASS_NAMES}
    >
      <div ref={nodeRef}>{children}</div>
    </CSSTransition>
  );
}

export default FacilityFormTransition;
